<template>
  <div class="account-user">
    <vue-feather type="user"></vue-feather>
  </div>
  <ul class="profile-dropdown onhover-show-div">
    <li>
      <router-link to="/profile">
        <vue-feather type="user"></vue-feather>
        <span>Account</span>
      </router-link>
    </li>
    <li>
      <router-link to="/inbox">
        <vue-feather type="mail"></vue-feather>
        <span>Inbox</span>
      </router-link>
    </li>
    <li>
      <router-link to="/settings">
        <vue-feather type="settings"></vue-feather>
        <span>Settings</span>
      </router-link>
    </li>
    <li>
      <a href="javascript:void(0)" @click.prevent="logout">
        <vue-feather type="log-out"></vue-feather>
        <span>Log Out</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
  },
};
</script>
